<template>
  <a-card :bordered="false">
    <Breadcrumb routeName="MemberLists" toName="交易明细" goPathName="会员卡"></Breadcrumb>
    <a-row class="status-list">
      <a-col :xs="6" :sm="6" v-if="amountInfo.issuedAmount != null">
        <div class="text">会员卡发放总金额</div>
        <div class="heading"><span>{{ amountInfo.issuedAmount }}</span><i> 元</i></div>
      </a-col>
      <a-col :xs="6" :sm="6">
        <div class="text">会员卡激活总金额</div>
        <div class="heading"><span style="color: #FEA834;">{{ amountInfo.activeAmount }}</span><i> 元</i></div>
      </a-col>
      <a-col :xs="6" :sm="6">
        <div class="text">已使用金额</div>
        <div class="heading"><span style="color: #FF7300;">{{ amountInfo.usedAmount }}</span><i> 元</i></div>
      </a-col>
      <a-col :xs="6" :sm="6">
        <div class="text">剩余金额</div>
        <div class="heading"><span style="color: #f5222d">{{ amountInfo.surplusAmount }}</span><i> 元</i></div>
      </a-col>
    </a-row>
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="激活人" v-bind="searchItemLayout">
            <a-input v-model="queryParams.activeMemberNickName" allow-clear placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="激活号码" v-bind="searchItemLayout">
            <a-input v-model="queryParams.activeMemberMobile" allow-clear placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="激活时间" v-bind="searchItemLayout">
            <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
          </a-form-item>
        </search-list>
      </search-header>
      <search-header :col="1">
        <search-list>
          <a-form-item>
            <a-button style="margin-left: 8%" type="primary" @click="searchBtn">查询</a-button>
            <a-button @click="exportData">批量导出</a-button>
            <a-button @click="handleLook">查看已生成报表</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <custom-page-table
      ref="table"
      rowKey="id"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <div slot="actionName" slot-scope="data">
        {{ data.text }}<br/>{{ data.record.activeMemberMobile }}
      </div>
      <span class="price-class" slot="moneySlots" slot-scope="data">￥{{ data.text }}</span>
    </custom-page-table>
  </a-card>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import searchForm from '@/utils/mixins/searchFormMixins'
import moment from 'moment'

export default {
  name: 'MemberCardTransactionDetail',
  mixins: [searchForm],
  components: {
    Breadcrumb
  },
  data() {
    return {
      moment,
      selectedDate: undefined,
      cardId: '',
      merchantId: this.$store.getters.userInfo.merchantId,
      queryParams: {
        membershipCardId: this.$route.query.cardId,
        activeEndDay: '',
        activeMemberNickName: '',
        activeMemberMobile: '',
        activeStartDay: ''
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '卡号',
          dataIndex: 'id'
        },
        {
          title: '激活时间',
          dataIndex: 'activeTime'
        },
        {
          title: '激活人',
          dataIndex: 'activeMember'
        },
        {
          title: '类型',
          dataIndex: 'orderTypeStr'
        },
        {
          title: '下单时间',
          dataIndex: 'orderTime'
        },
        {
          title: '金额',
          dataIndex: 'amountStr'
        },
        {
          title: '订单号',
          dataIndex: 'orderNo'
        },
        {
          title: '所属店铺',
          dataIndex: 'orderShopName'
        }
      ],
      selectedDateTime: '',
      amountInfo: {}
    }
  },
  mounted() {
    this.cardId = this.$route.query.cardId
    this.getCardAmountInfo(this.cardId)
  },
  methods: {
    getListPromise(params) {
      return this.getHttpServices().getUserService().post('member/v2/card/getMembershipCardWriteOffData', params)
    },
    getCardAmountInfo(id) {
      this.getHttpServices().getUserService().post('member/v2/card/getMembershipCardAmountData', {
        membershipCardId: id
      }).then(res => {
        this.amountInfo = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.activeStartDay = dateStrArr[0]//购买开始日期
      this.queryParams.activeEndDay = dateStrArr[1]//购买结束日期
    },
    searchBtn() {
      this.getCardAmountInfo(this.cardId)
      this.$refs.table.refresh(true)
    },
    goBack() {
      this.$router.go(-1)
    },
    handleLook() {
      this.$router.push({
        name: 'DownloadTable'
      })
    },
    exportData() {
      this.searchBtn()
      this.getHttpServices().getUserService().post('member/v2/card/writeOffDataExport', this.queryParams)
        .then(res => {
          this.$message.success('批量导出成功，请去报表中心下载')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>

<style lang="less" scoped>
.status-list {
  background-color: #F5F5F6;
  padding: 20px;
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 8px;

  .text {
    margin-bottom: 10px;
  }

  .heading {
    i {
      font-size: 11px;
      font-style: normal;
    }
  }
}

.ant-btn + .ant-btn {
  margin-left: 10px;
}
</style>